import { HttpApiError, HttpApiGroup } from "@effect/platform";
import { Schema } from "effect";
import { endpoint } from "../auth/endpoint";
import { DatabaseError, DataIntegrityError } from "../auth/errors";

import { AccountId, ShopperAiIntegrationId } from "../ids/definitions";
import {
  IntegrationCursor,
  IntegrationWithChannelDataResponse,
  UpdateContactFormIntegrationInput,
} from "../models/shopper-ai/integration/integration";
import {
  CursorPaginatedResponse,
  CursorPaginationParams,
} from "../schema/pagination";

export const IntegrationGroup = HttpApiGroup.make("integration")
  .add(
    endpoint.merchant
      .get("getTeamIntegrations", "/integrations")

      .setUrlParams(CursorPaginationParams(IntegrationCursor))
      .addSuccess(
        CursorPaginatedResponse(
          IntegrationWithChannelDataResponse,
          IntegrationCursor,
        ),
      )
      .addError(HttpApiError.Forbidden)
      .addError(DatabaseError)
      .addError(DataIntegrityError),
  )
  .add(
    endpoint.merchant
      .get("getIntegration", "/integrations/:id")

      .setPath(Schema.Struct({ id: ShopperAiIntegrationId }))
      .addSuccess(IntegrationWithChannelDataResponse)
      .addError(HttpApiError.NotFound)
      .addError(HttpApiError.Forbidden)
      .addError(DatabaseError)
      .addError(DataIntegrityError),
  )
  .add(
    endpoint.merchant
      .get("getIntegrationsByAccount", "/accounts/:accountId/integrations")

      .setPath(Schema.Struct({ accountId: AccountId }))
      .setUrlParams(CursorPaginationParams(IntegrationCursor))
      .addSuccess(
        CursorPaginatedResponse(
          IntegrationWithChannelDataResponse,
          IntegrationCursor,
        ),
      )
      .addError(HttpApiError.NotFound)
      .addError(HttpApiError.Forbidden)
      .addError(DatabaseError)
      .addError(DataIntegrityError),
  )
  .add(
    endpoint.merchant
      .patch("updateContactFormIntegration", "/integrations/contact-form")
      .setPayload(UpdateContactFormIntegrationInput)
      .addSuccess(Schema.Struct({ ok: Schema.Literal(true) }))
      .addError(HttpApiError.Forbidden)
      .addError(HttpApiError.BadRequest)
      .addError(DatabaseError)
      .addError(DataIntegrityError),
  )
  .prefix("/api");
